import { useTranslation } from "react-i18next";

export const useTimeFormatter = () => {
    const { t } = useTranslation();
    
    const getWord = (value: number, type: 'hour' | 'minute'): string => {
        const lastDigit = value % 10;
        const lastTwoDigits = value % 100;
        
        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return t(`chat.${type}s5`);
        }
        if (lastDigit === 1) {
            return t(`chat.${type}`);
        }
        if (lastDigit >= 2 && lastDigit <= 4) {
            return t(`chat.${type}s2`);
        }
        return t(`chat.${type}s5`);
    };
    
    const formatEstimatedHour = (hours: number): string => {
        if (hours <= 0) return '';
        
        const estimatedTimeText = t('chat.estimatedTime');
        const wholeHours = Math.floor(hours);
        const minutes = Math.round((hours - wholeHours) * 60);
        
        if (wholeHours === 0 && minutes > 0) {
            return `${estimatedTimeText} - ${minutes} ${getWord(minutes, 'minute')}`;
        }
        
        if (minutes === 0) {
            return `${estimatedTimeText} - ${wholeHours} ${getWord(wholeHours, 'hour')}`;
        }
        
        return `${estimatedTimeText} - ${wholeHours} ${getWord(wholeHours, 'hour')} ${minutes} ${getWord(minutes, 'minute')}`;
    };
    
    return { formatEstimatedHour };
};